// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import VueClipboard from 'vue-clipboard2'
import '../theme/249CE6/index.css'
import './styles/common.scss'

import Mint from 'mint-ui'
import VueLazyload from 'vue-lazyload'
import 'mint-ui/lib/style.css'
Vue.use(Mint)
Vue.use(ElementUI, {size: 'medium', zIndex: 300})
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
  loading: null
})
Vue.use(VueClipboard)

/**
 * 对vue-devtools进行配置
 * 只有本地开发 和 测试 才开启调试功能
 */
let isDebug = true
if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'pre') {
  isDebug = false
}
Vue.config.debug = isDebug
Vue.config.devtools = isDebug
Vue.config.productionTip = isDebug

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

router.afterEach((to, from, next) => {
  setTimeout(() => {
    (function () {
      document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove()
      var hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?e39c76a678677c57f42af46e3e759551'
      hm.id = 'baidu_tj'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    })()
  }, 0)
})



// WEBPACK FOOTER //
// ./src/main.js